import { render, staticRenderFns } from "./MenuDownIcon.vue?vue&type=template&id=1c38f9f2&scoped=true"
import script from "./MenuDownIcon.vue?vue&type=script&lang=js"
export * from "./MenuDownIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuDownIcon.vue?vue&type=style&index=0&id=1c38f9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38f9f2",
  null
  
)

export default component.exports